import { useNavigate, Link } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { usePermissions } from '@/hooks/usePermissions';
import { useProductStore } from '@/stores/product';
import './NotFoundPage.css';

type HomeRouteInfo = { path: string; label: string };

function useHomeRoute(): HomeRouteInfo {
  const { branding } = useProductStore();
  const { can } = usePermissions();

  if (branding) {
    return { path: '/bi', label: 'Go to dashboards' };
  }
  if (can('analytics.dashboards')) {
    return { path: '/bi', label: 'Go to dashboards' };
  }
  if (can('data_lake.catalog')) {
    return { path: '/catalog', label: 'Browse catalog' };
  }
  if (can('data_lake.explorer')) {
    return { path: '/queries', label: 'Open explorer' };
  }
  if (can('ingestion.data_sources')) {
    return { path: '/data-sources', label: 'View data sources' };
  }
  if (can('ingestion.pipelines')) {
    return { path: '/pipelines', label: 'View pipelines' };
  }
  if (can('get_started.setup_guide')) {
    return { path: '/setup', label: 'Go to setup' };
  }
  return { path: '/settings', label: 'Open settings' };
}

export default function NotFoundPage() {
  const navigate = useNavigate();
  const homeRoute = useHomeRoute();

  return (
    <div className="not-found-page">
      <div className="not-found-code" aria-hidden="true">
        404
      </div>
      <div className="not-found-content">
        <p className="not-found-kicker">Page Not Found!</p>
        <h1 className="not-found-title">This destination doesn't exist in the portal.</h1>
        <p className="not-found-description">
          The link may be outdated or the page was moved. Use the shortcuts below to get back on track.
        </p>
        <div className="not-found-actions">
          <button className="not-found-btn-secondary" onClick={() => void navigate(-1)}>
            <ArrowLeft size={14} />
            Go back
          </button>
          <Link to={homeRoute.path} className="not-found-btn-primary">
            {homeRoute.label}
          </Link>
        </div>
      </div>
    </div>
  );
}
